// extracted by mini-css-extract-plugin
export default {"button":"Button_button__g5JK8","rainbow":"Button_rainbow__n2rMk","ghost":"Button_ghost__veJPu","ghost-sm":"Button_ghost-sm__hN3DJ","small":"Button_small__8KDcx"};